export default __webpack_public_path__ + "static/header-bg-fd84dcbbb222740ea814e4ceb2097ac2.jpg";